import type { Injector } from '@angular/core';

import { createProviderClass } from '@core/common-legacy';

import { IconName } from '../common/icon/icons.type';

export abstract class IconsContainerStrategy {
  public abstract load(name: IconName, element: HTMLElement, injector: Injector): Promise<void>;
}

export const { provide: provideIconsContainerStrategy, inject: injectIconsContainerStrategy } =
  createProviderClass(IconsContainerStrategy)();
